import React from 'react';

const NavBadge = ({ items }) => {
    let navBadges = false;
    if (items.badge) {
        const badgeClass = ['label', 'pcoded-badge ml-1', items.badge.type];

        // Verifica se o badge é um emoji especial
        let badgeContent = items.badge.title;
        if (items.badge.title === '1') {
            badgeContent = '🔥'; // Emoji de fogo
        } else if (items.badge.title === '2') {
            badgeContent = '🚀'; // Emoji de foguete
        }

        navBadges = (
            <span className={badgeClass.join(' ')}>
                {badgeContent}
            </span>
        );
    }

    return (
        <React.Fragment>
            {navBadges}
        </React.Fragment>
    );
};

export default NavBadge;
